import { createContext, useMemo, ReactNode } from 'react';

interface WidgetPage {
  id: string;
  skipCertificate: boolean;
}

export const WidgetPageContext = createContext<WidgetPage>({
  id: '',
  skipCertificate: false,
});

interface WidgetPageContextProviderProps {
  page: string;
  children: ReactNode;
}

const PAGES_WITHOUT_CERTIFICATE = ['header', 'sideMenu'];

export const WidgetPageContextProvider = ({
  page,
  children,
}: WidgetPageContextProviderProps) => {
  const value = useMemo(
    () => ({
      id: page,
      skipCertificate: PAGES_WITHOUT_CERTIFICATE.includes(page),
    }),
    [page],
  );

  return (
    <WidgetPageContext.Provider value={value}>
      {children}
    </WidgetPageContext.Provider>
  );
};
